import "./SinglePostTemplate.module.css"
import UstMenu from "@/reusable_sections/Header"
import SinglePostTemplateSection from "./sections/SinglePostTemplateSection"
import CorporateFooter from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <UstMenu />
      <SinglePostTemplateSection />
      <CorporateFooter />
    </div>
  )
}
